/**
 * 「ゲームのファイルを入れるだけの小さな画面」（pages/UploadPage.tsx・2026-10-04 creator/web-upload）の英語。
 * en.ts が `...enUpload` で取り込む（ja.upload.ts が同じキーを全部持つことを型で強制）。
 *
 * 言葉の決め事（キーを入れる画面 en.enterKey.ts と同じ・uploadFiles.test.ts が見張る）:
 *   - upload / hosting / deploy / environment / production / version / token などの中の言葉を使わない。見える物で言う（"zip"・"folder"・"files"）。
 *     zip は利用者がチャットでダウンロードする物の名前 = 見える物（AI も「zip をダウンロードして」と言う）
 *   - どこに入るか: production = "your published app ({url})" / development = "your test app ({url})"（MCP の placeWords と同じ）
 *   - 終わったら「チャットに戻って」（founder の言い方・閉じた機能 chat とは別 = wordsPass.test.ts の ALLOWED に理由つき）
 */
export const enUpload = {
  'upload.title': "Add your app's files",
  'upload.titleFor': 'Add the files of "{name}"',
  'upload.lead': 'Drop the zip of the app you made in the chat here (a folder works too).',
  'upload.where.production': 'They go into your published app ({url}). Before the change goes out, the chat asks you once more.',
  'upload.where.development': 'They go into your test app ({url}). You can try it right after.',
  'upload.where.productionNoUrl': 'They go into your published app. Before the change goes out, the chat asks you once more.',
  'upload.where.developmentNoUrl': 'They go into your test app. You can try it right after.',
  'upload.drop': 'Drop a zip or a folder here',
  'upload.or': 'or',
  'upload.pickZip': 'Choose a zip',
  'upload.pickFolder': 'Choose a folder',
  'upload.reading': 'Opening the zip…',
  'upload.ready': '{count} files, {size}',
  'upload.skipped': '{count} files are left out (files your computer adds by itself, and key files such as .env).',
  'upload.button': 'Add',
  'upload.working': 'Adding… {percent}%',
  'upload.doneTitle': 'Added',
  'upload.doneBody.development': 'Go back to the chat. You can close this page.',
  'upload.doneBody.production': 'Go back to the chat and answer whether to make it public. You can close this page.',
  'upload.doneUrl': 'Try it here: {url}',
  'upload.again': 'Add other files',
  'upload.badLink': 'This link is not right. Ask the AI to open the page again.',
  'upload.issue.empty': 'There were no files to add.',
  'upload.issue.noIndex': 'There is no index.html at the top. Ask the AI to make the zip again with index.html in it.',
  'upload.zip.not_zip': 'This could not be opened as a zip. Check that the download finished, then drop it again.',
  'upload.zip.encrypted': 'A zip with a password cannot be opened. Make it again without a password.',
  'upload.zip.too_big': 'This zip is too big to open here. Unzip it and drop the folder instead.',
  'upload.zip.unsupported': 'This zip was made in a way this page cannot open. Make it again with the usual settings.',
  'upload.zip.broken': 'A file in this zip is damaged. Download it again, then drop it here.',
  'upload.noUnzip': 'This browser cannot open zips. Unzip it and drop the folder, or use a newer browser.',
  'upload.error.off': 'Your test app is not turned on yet. Ask the AI in the chat to "turn on publishing", then add the files here again.',
  'upload.error.keyFound': 'Not added: something that looks like a key was found in {files}. Tell the AI, and ask it to take the key out of the app files.',
  'upload.error.rateLimited': 'You added files many times in a short while. Wait about {seconds} seconds and try again.',
  'upload.error.tooMany': 'Too many unfinished tries are waiting. Wait a little and try again.'
} as const;
